export const ICONS: Record<string, string> = {
  rw: "/assets/rw.avif",
  claroread: "/assets/claroread.png",
  mindview: "/assets/mindview.png",
  mindview_online: "/assets/mindview-online.png",
  mindview_assist: "/assets/mindview-assist.png",
  android: "/assets/android.svg",
  ios: "/assets/safari.svg",
  tasks: "/assets/tasks.png",
  windows: "/assets/windows.png",
  macos: "/assets/macos.svg",
  chrome: "/assets/chrome.png",
  browser: "/assets/browser.svg",
  chromeos: "/assets/chromeos.png",
  edge: "/assets/edge.png",
  safari: "/assets/safari.svg",
  google: "/assets/google.svg",
  microsoft: "/assets/microsoft.svg",
};

export const FLAG_CLASS: Record<string, string> = {
  gb: "fi fi-gb",
  us: "fi fi-us",
  dk: "fi fi-dk",
  se: "fi fi-se",
  no: "fi fi-no",
  fr: "fi fi-fr",
  de: "fi fi-de",
};

export const FLAG_EMOJI: Record<string, string> = {
  gb: "🇬🇧",
  us: "🇺🇸",
  dk: "🇩🇰",
  se: "🇸🇪",
  no: "🇳🇴",
  fr: "🇫🇷",
  de: "🇩🇪",
};
